import { render, staticRenderFns } from "./Notifications.vue?vue&type=template&id=070b2d8e&"
import script from "./Notifications.vue?vue&type=script&lang=js&"
export * from "./Notifications.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/media/thed/vol_40/Laravel/bmat/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('070b2d8e')) {
      api.createRecord('070b2d8e', component.options)
    } else {
      api.reload('070b2d8e', component.options)
    }
    module.hot.accept("./Notifications.vue?vue&type=template&id=070b2d8e&", function () {
      api.rerender('070b2d8e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/views/admin/components/Notifications.vue"
export default component.exports